module.exports = __webpack_public_path__ + "static/32-5ec8a21533dd17928ef235214d95d2b7.jpg";